const PROGRESSER_URL = process.env.REACT_APP_PROGRESSER_URL;
const SCRIBBLE_URL = process.env.REACT_APP_SCRIBBLE_URL;
const WORDPRESS_URL = process.env.REACT_APP_WORDPRESS_URL;

const DEFAULT_THEME = {
  primary: '#37484f',
  secondary: '#263238',
  tertiary: '#00BFA5',
  quarternary: '#455a64'
};

export { PROGRESSER_URL, SCRIBBLE_URL, WORDPRESS_URL, DEFAULT_THEME };



// WEBPACK FOOTER //
// ./src/utils/constants.js